var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('cs-preloader-overlay', {
    attrs: {
      "loading": _vm.loading
    }
  }, [_c('div', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "header-container"
  }, [_c('responsive-controller', {
    scopedSlots: _vm._u([{
      key: "tablet",
      fn: function fn() {
        return [_c('screen-header', {
          attrs: {
            "history-mode": false,
            "title": _vm.$t('project.settings')
          },
          on: {
            "navigate": function navigate($event) {
              return _vm.$router.push({
                name: 'cabinet'
              });
            }
          }
        })];
      },
      proxy: true
    }, {
      key: "default",
      fn: function fn() {
        return [_c('div', [_c('navigate-button', {
          directives: [{
            name: "absolute",
            rawName: "v-absolute"
          }, {
            name: "left",
            rawName: "v-left",
            value: -80,
            expression: "-80"
          }],
          on: {
            "navigate": function navigate($event) {
              return _vm.$router.push({
                name: 'cabinet'
              });
            }
          }
        }), _c('screen-title', {
          attrs: {
            "title": _vm.$t('project.settings')
          }
        })], 1)];
      },
      proxy: true
    }])
  })], 1), _c('div', {
    staticClass: "form-container"
  }, [_c('div', {
    staticClass: "download-container"
  }, [_c('attachment-image', {
    attrs: {
      "link": _vm.attachment.link,
      "input-id": "project.attachment"
    },
    on: {
      "loading": _vm.onImageLoading,
      "uploaded": function uploaded(data) {
        return _vm.attachment.setData(data);
      },
      "reset": function reset($event) {
        return _vm.attachment.reset();
      }
    }
  })], 1), _c('substrate-mount', [_c('div', {
    staticClass: "input-container"
  }, [_c('input-text', {
    ref: "name",
    attrs: {
      "input-id": "input-email",
      "input-name": _vm.$t('common.name'),
      "input-placeholder": _vm.$t('enter.title.or.name'),
      "max-length": 60,
      "min-length": 3,
      "readonly": !_vm.projectValidated
    },
    model: {
      value: _vm.name,
      callback: function callback($$v) {
        _vm.name = $$v;
      },
      expression: "name"
    }
  })], 1), _c('div', {
    staticClass: "input-container"
  }, [_c('input-textarea', {
    ref: "inp",
    attrs: {
      "input-id": "input-description",
      "input-name": _vm.$t('project.description'),
      "input-title": _vm.$t('enter.description'),
      "input-placeholder": _vm.$t('project.description'),
      "max-length": 255,
      "rows": 1
    },
    model: {
      value: _vm.description,
      callback: function callback($$v) {
        _vm.description = $$v;
      },
      expression: "description"
    }
  })], 1), _c('div', {
    staticClass: "input-container"
  }, [_c('input-link', {
    ref: "link",
    attrs: {
      "input-id": "project-link",
      "input-name": _vm.$t('link.to.project'),
      "input-placeholder": _vm.$t('indicate.link.to.project'),
      "readonly": ""
    },
    model: {
      value: _vm.link,
      callback: function callback($$v) {
        _vm.link = $$v;
      },
      expression: "link"
    }
  })], 1), _c('div', {
    staticClass: "input-container"
  }, [_c('input-id', {
    ref: "code",
    attrs: {
      "input-id": "project-index",
      "input-name": _vm.$t('project.id'),
      "input-placeholder": _vm.$t('indicate.project.id')
    },
    model: {
      value: _vm.code,
      callback: function callback($$v) {
        _vm.code = $$v;
      },
      expression: "code"
    }
  })], 1), _c('div', {
    staticClass: "input-container"
  }, [_c('input-text', {
    ref: "apiKey",
    attrs: {
      "input-id": "merchant-apiKey",
      "input-name": _vm.$t('token.for.api'),
      "input-placeholder": _vm.$t('token.for.api'),
      "data-private": "",
      "disabled": "",
      "readonly": ""
    },
    model: {
      value: _vm.apiKey,
      callback: function callback($$v) {
        _vm.apiKey = $$v;
      },
      expression: "apiKey"
    }
  })], 1), _vm.currency ? _c('div', {
    staticClass: "option-container",
    on: {
      "click": _vm.handleShownCurrenciesList
    }
  }, [_c('option-panel', {
    attrs: {
      "option": _vm.currency,
      "noactive": ""
    }
  }, [_c('div', {
    class: _vm.$style.iconCurrency,
    attrs: {
      "slot": "icon"
    },
    slot: "icon"
  }, [_vm._v(" " + _vm._s(_vm.currency.sign) + " ")]), _vm.isChangeCurrencyPermission ? _c('cs-button', {
    attrs: {
      "type": "secondary"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.change')) + " ")]) : _vm._e()], 1)], 1) : _vm._e(), _vm.localization ? _c('div', {
    staticClass: "option-container",
    on: {
      "click": _vm.handleShownLocalizationList
    }
  }, [_c('option-panel', {
    attrs: {
      "option": _vm.localization,
      "noactive": ""
    }
  }, [_c('div', {
    class: _vm.$style.iconLocalization,
    attrs: {
      "slot": "icon"
    },
    slot: "icon"
  }, [_c('country-flag', {
    attrs: {
      "language-code": _vm.localization.code
    }
  })], 1), _c('cs-button', {
    attrs: {
      "type": "secondary"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.change')) + " ")])], 1)], 1) : _vm._e()]), _c('div', {
    staticClass: "button-primary-container"
  }, [_c('cs-button', {
    attrs: {
      "width": 300,
      "disabled": !_vm.isValid
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.save')) + " ")])], 1)], 1), _c('cs-dialog', {
    model: {
      value: _vm.isShownCurrencies,
      callback: function callback($$v) {
        _vm.isShownCurrencies = $$v;
      },
      expression: "isShownCurrencies"
    }
  }, [_c('dialog-list-layout', _vm._l(_vm.getPreparedCurrencies, function (currency) {
    return _c('option-panel', {
      key: currency.id,
      attrs: {
        "option": currency
      },
      on: {
        "click": _vm.handleChangeCurrency
      }
    }, [_c('div', {
      class: _vm.$style.iconCurrency,
      attrs: {
        "slot": "icon"
      },
      slot: "icon"
    }, [_vm._v(" " + _vm._s(currency.sign) + " ")])]);
  }), 1)], 1), _c('cs-dialog', {
    model: {
      value: _vm.isShownCurrencyError,
      callback: function callback($$v) {
        _vm.isShownCurrencyError = $$v;
      },
      expression: "isShownCurrencyError"
    }
  }, [_c('dialog-default-layout', [_c('h2', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t('change.of.currency')))]), _c('p', {
    staticClass: "dialog-text",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v(" " + _vm._s(_vm.$t('change.of.currency.error')) + " ")]), _c('div', {
    staticClass: "confirmation-control-buttons",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "confirmation-control-active"
  }, [_c('cs-button', {
    attrs: {
      "width": "100%"
    },
    on: {
      "click": _vm.handlePayoutRedirect
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('to.payout')) + " ")])], 1), _c('div', {
    staticClass: "confirmation-control-cancel"
  }, [_c('cs-button', {
    attrs: {
      "width": "100%",
      "type": "transparent"
    },
    on: {
      "click": function click($event) {
        _vm.isShownCurrencyError = false;
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.cancel')) + " ")])], 1)])])], 1), _c('languages-list-modal', {
    attrs: {
      "languages": _vm.formattedLanguages
    },
    on: {
      "change-localization": _vm.handleChangeLocalization
    },
    model: {
      value: _vm.isShownLocalizationList,
      callback: function callback($$v) {
        _vm.isShownLocalizationList = $$v;
      },
      expression: "isShownLocalizationList"
    }
  })], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }